module.exports = __webpack_public_path__ + "img/spotify.ac05e0ec.svg";